import './ApplicationControl.scss'

import { createRestClient } from '@/contexts/QueryProvider'
import { useGetSearchParam } from '@/hooks'
import { ApplicationsTable } from './ApplicationsTable'
import { ApplicationTabs } from './ApplicationTabs'
import { useSetHeaderContext } from '@/layouts/MainLayout/HeaderContext'
import { AppGeneric20Regular } from '@fluentui/react-icons'

export const ApplicationControl = () => {
  const appId = useGetSearchParam<number>('appId')

  const { getApplicationsApiGetApplications } = createRestClient()

  // Queries
  const { data: applications } = getApplicationsApiGetApplications.useQuery()

  const app = applications?.find((x) => x.applicationId === appId)
  const applicationName = app?.appName

  useSetHeaderContext({
    rightTitle: applicationName ? { text: applicationName, icon: AppGeneric20Regular } : undefined,
  })

  return (
    <div className="applications">
      <div className="container">
        <ApplicationsTable />
        <ApplicationTabs app={app} />
      </div>
    </div>
  )
}
